import { StyleSheet } from 'react-native'
import type { Theme } from '../src/theme/getTheme'

export const getLeagueDetailStyles = (theme: Theme) =>
  StyleSheet.create({
    container: { flex: 1, backgroundColor: theme.background.primary },
  })
